import { projectPath } from "@/routes/app-navigation";
import { lazyPage, type PreloadablePage } from "@/routes/lazy-page";

export type ProjectSettingsTab = {
	/** URL segment: `/p/:projectId/settings/:id`. */
	id: string;
	label: string;
	/** Reads the project via `useCurrentProject()`; code-split so the palette can list tabs cheaply. */
	page: PreloadablePage;
};

/**
 * Project settings tabs, in order (the first is also `/p/:projectId/settings`). Appending an entry
 * here adds the tab to the settings page, its `1`–`9` shortcuts and the command palette.
 */
export const projectSettingsTabs: ProjectSettingsTab[] = [
	{
		id: "general",
		label: "General & brand",
		page: lazyPage(() => import("./general-settings"), "GeneralSettings"),
	},
	{
		id: "channels",
		label: "Channels",
		page: lazyPage(() => import("./channels-settings"), "ChannelsSettings"),
	},
	{
		id: "monitoring",
		label: "Monitoring",
		page: lazyPage(() => import("./monitoring-card"), "MonitoringSettingsTab"),
	},
	{
		id: "agents",
		label: "Agents",
		page: lazyPage(() => import("./agents-settings"), "AgentsSettings"),
	},
];

export const projectSettingsPath = (projectId: string, tab?: string) =>
	projectPath(projectId, tab ? `settings/${tab}` : "settings");
